function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "9A3B65EF-F1EE-4B77-9070-0629BA031699");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "staffNewBulk",
  transform: "translate(-993.000000, -701.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(981.000000, 693.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(12.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Icon-BG",
  fill: "#BBE5B3",
  cx: 14,
  cy: 14,
  r: 14
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Fill",
  fill: "#FFFFFF",
  cx: 10,
  cy: 10,
  r: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,0 C4.486,0 0,4.486 0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0 M10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 M12.293,7.293 L9,10.586 L7.707,9.293 C7.316,8.902 6.684,8.902 6.293,9.293 C5.902,9.684 5.902,10.316 6.293,10.707 L8.293,12.707 C8.488,12.902 8.744,13 9,13 C9.256,13 9.512,12.902 9.707,12.707 L13.707,8.707 C14.098,8.316 14.098,7.684 13.707,7.293 C13.316,6.902 12.684,6.902 12.293,7.293",
  id: "Mask",
  fill: "#108043"
}))))));

var SvgFeedbackSuccess = function SvgFeedbackSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedbackSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback-success.4adc06d2.svg";
export { ForwardRef as ReactComponent };